var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.string.includes.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import css from './style.pcss';
var LUXID_KEY = "oidc-myid";
var RtlLuxidCheck = /*#__PURE__*/function (_LitElement) {
  _inherits(RtlLuxidCheck, _LitElement);
  function RtlLuxidCheck() {
    var _this;
    _classCallCheck(this, RtlLuxidCheck);
    _this = _callSuper(this, RtlLuxidCheck);
    _this.loggedIn = false;
    _this.loaded = false;
    _this.gigya = window.gigya;
    _this.user = {};
    _this.checkUserLoggedIn();
    _this.loginUrl = '//login.rtl.lu';
    _this.currentUrl = window.location.href;
    _this.addGigyaEventHandler();
    return _this;
  }
  _createClass(RtlLuxidCheck, [{
    key: "addGigyaEventHandler",
    value: function addGigyaEventHandler() {
      var _this2 = this;
      if (!window.gigya) {
        setTimeout(function () {
          return _this2.addGigyaEventHandler();
        }, 200);
      } else {
        this.gigya = window.gigya;
        this.gigya.socialize.addEventHandlers({
          onLogin: function onLogin() {
            _this2.gigya.accounts.setSSOToken();
          }
        });
      }
    }
  }, {
    key: "getAccountInfoResponse",
    value: function getAccountInfoResponse(response) {
      this.loaded = true;
      if (parseInt(response.errorCode) === 0 && response.user.UID) {
        window.rtlsites.config.uid = response.user.UID;
        this.user = response.user;
        console.log("zuser:", response.user);
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    }
  }, {
    key: "checkUserLoggedIn",
    value: function checkUserLoggedIn() {
      var _this3 = this;
      if (!window.gigya) {
        setTimeout(function () {
          return _this3.checkUserLoggedIn();
        }, 200);
      } else {
        this.gigya = window.gigya;
        this.gigya.socialize.getUserInfo({
          callback: function callback(r) {
            return _this3.getAccountInfoResponse(r);
          }
        });
      }
    }
  }, {
    key: "logout",
    value: function logout() {
      var _this4 = this;
      this.loggedIn = false; // Hieren callback brauch emmer seu OP MANST 5 Sekonnen.
      // Vuque dass daat awer scheiss ass wann een seulaang keen feedback kritt,
      // setzten ech d'var direkt schon op false dass et seu ausgeseit wei wann een ausgeloggt wier,
      // obwuel een et dei eischt sekonnen nach net wierklech ass

      this.gigya.accounts.logout({
        callback: function callback(r) {
          return _this4.onLogout(r);
        }
      });
    }
  }, {
    key: "onLogout",
    value: function onLogout(response) {
      this.loggedIn = false;
      if (response.errorCode != 0) {
        console.log('Error :' + response.errorMessage);
      } else {
        this.loggedIn = false;
        location.reload();
      }
    }
  }, {
    key: "showLoginModal",
    value: function showLoginModal() {
      var lang = this.language;
      // if (lang === "lu") {
      //     lang = "fr-inf";
      // }
      // this.gigya.accounts.showScreenSet({
      //     screenSet: 'Default-RegistrationLogin-test',
      //     lang: lang,
      //     startScreen: 'link-luxid',
      //     onAfterSubmit: (resp) => {
      //         if (resp.response.errorCode == 0) {
      //             location.reload();
      //         }
      //     }
      //     // redirectURL: this.currentUrl+"/#/"
      // });

      this.gigya.accounts.showScreenSet({
        screenSet: 'Default-RegistrationLogin-test',
        lang: lang,
        startScreen: 'link-luxid',
        enabledProviders: 'facebook,googleplus',
        onAfterSubmit: function onAfterSubmit(resp) {
          if (resp.response.errorCode == 0) {
            location.reload();
          }
        }
        // redirectURL: this.currentUrl+"/#/"
      });
    }
  }, {
    key: "hideLoginDropdown",
    value: function hideLoginDropdown(e) {
      e.stopPropagation();
      var smenu = this.shadowRoot.querySelector('.rtl-login__submenu');
      if (smenu) smenu.classList.remove('rtl-login__submenu--active');
    }
  }, {
    key: "toggleLoginDropdown",
    value: function toggleLoginDropdown(e) {
      e.stopPropagation();
      var smenu = this.shadowRoot.querySelector('.rtl-login__submenu');
      if (smenu) smenu.classList.toggle('rtl-login__submenu--active');
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      document.addEventListener('click', function (e) {
        this.hideLoginDropdown(e, false);
      }.bind(this));
      var language = this.language ? this.language : 'lu';
      var hasLuxId = this.user && this.user.identities && Object.keys(this.user.identities).includes(LUXID_KEY);
      var content = html(_t || (_t = _``));
      if (this.loggedIn && this.user && this.user.identities && !hasLuxId) {
        content = html(_t2 || (_t2 = _`
                Wellsde keen luxid?
                <button @click=${0}>Link</button>
            `), function () {
          return _this5.showLoginModal();
        });
      }
      if (!this.loaded) content = html(_t3 || (_t3 = _``));
      return html(_t4 || (_t4 = _`
            <style>
                ${0}
            </style>
            ${0}
        `), css, content);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        loggedIn: {
          type: Boolean
        },
        loaded: {
          type: Boolean
        },
        language: {
          type: String
        },
        user: {
          type: Object
        }
      };
    }
  }]);
  return RtlLuxidCheck;
}(LitElement);
export { RtlLuxidCheck as default };
window.customElements.define('rtl-luxid-check', RtlLuxidCheck);